"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Client = void 0;
const axios_1 = __importDefault(require("axios"));
const marketing_utils_1 = require("@swyftx/marketing-utils");
const constants_1 = require("../constants");
const errors_1 = require("../errors");
const serialization_1 = require("../serialization");
class Client {
    constructor(options) {
        this.client = axios_1.default.create({
            baseURL: `${options.serviceUrl}${options.servicePrefix}`,
            timeout: options.requestTimeout,
            validateStatus: () => true,
            withCredentials: options.withCredentials,
            headers: options.headers,
        });
    }
    async getAllCohorts(options = {}) {
        const cohorts = [];
        let page;
        while (page === undefined || page.currentPage < page.totalPages) {
            page = await this.getCohorts({
                ...options,
                pageNumber: page === undefined ? 1 : page.currentPage + 1,
                itemsPerPage: constants_1.MAX_ITEMS_PER_PAGE,
            });
            cohorts.push(...page.cohorts);
        }
        return cohorts;
    }
    async getCohorts(options) {
        const { data, status } = await marketing_utils_1.http.apiGet(this.client, `/cohorts`, options);
        if (!marketing_utils_1.http.isHttpSuccess(status))
            throw new errors_1.ServerError(`Could not get cohorts`, data);
        return (0, serialization_1.parseCohortsPage)(data);
    }
    async getFirstCohort(options) {
        const page = await this.getCohorts({
            ...options,
            pageNumber: 1,
            itemsPerPage: 1,
        });
        return page.cohorts.length ? page.cohorts[0] : null;
    }
    async getCohortById(id) {
        const { data, status } = await marketing_utils_1.http.apiGet(this.client, `/cohorts/${id}`);
        if (marketing_utils_1.http.isHttpNotFound(status))
            return null;
        if (!marketing_utils_1.http.isHttpSuccess(status))
            throw new errors_1.ServerError(`Could not get cohort with ID ${id}`, data);
        return (0, serialization_1.parseCohort)(data);
    }
    async syncCohorts() {
        const { data, status } = await marketing_utils_1.http.apiPost(this.client, '/cohorts/sync');
        if (!marketing_utils_1.http.isHttpSuccess(status))
            throw new errors_1.ServerError(`Could not sync cohorts`, data);
    }
    async syncCohortUsers(cohortId) {
        const { data, status } = await marketing_utils_1.http.apiPost(this.client, `/cohorts/${cohortId}/syncUsers`);
        if (marketing_utils_1.http.isHttpNotFound(status))
            throw new errors_1.CohortNotFoundError(`Cohort with ID ${cohortId} not found`);
        if (!marketing_utils_1.http.isHttpSuccess(status))
            throw new errors_1.ServerError(`Could not sync users for cohort with ID ${cohortId}`, data);
        return (0, serialization_1.parseCohort)(data);
    }
    async updateCohortById(id, options) {
        const { data, status } = await marketing_utils_1.http.apiPatch(this.client, `/cohorts/${id}`, options);
        if (marketing_utils_1.http.isHttpNotFound(status))
            throw new errors_1.CohortNotFoundError(`Cohort with ID ${id} not found`);
        if (!marketing_utils_1.http.isHttpSuccess(status))
            throw new errors_1.ServerError(`Could not update cohort with ID ${id}`, data);
        return (0, serialization_1.parseCohort)(data);
    }
    async getAllUserCohortIds(userId, options = {}) {
        const cohortIds = [];
        let page;
        while (page === undefined || page.currentPage < page.totalPages) {
            page = await this.getUserCohortIds(userId, {
                ...options,
                pageNumber: page === undefined ? 1 : page.currentPage + 1,
                itemsPerPage: constants_1.MAX_ITEMS_PER_PAGE,
            });
            cohortIds.push(...page.cohortIds);
        }
        return cohortIds;
    }
    async getUserCohortIds(userId, options) {
        const { data, status } = await marketing_utils_1.http.apiGet(this.client, `/user-cohorts/${userId}`, options);
        if (!marketing_utils_1.http.isHttpSuccess(status))
            throw new errors_1.ServerError(`Could not get user cohorts`, data);
        return data;
    }
}
exports.Client = Client;
//# sourceMappingURL=client.js.map